import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import {RouterOutlet} from '@angular/router';
import {RecaptchaV3Module} from 'ng-recaptcha-2';
import {FooterComponent} from '../shared/components/footer/footer.component';
import {HeadComponent} from '../shared/components/head/head.component';
import {VehicleBrand} from '../domain/core/vehicle-brand.model';
import {LegalEntity} from '../domain/core/legal-entity.model';
import {AppState} from '../shared/utils/AppState';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet, RecaptchaV3Module, FooterComponent, HeadComponent]
})
export class AppComponent {
  constructor() {
    if (!environment.logEnabled) {
      console.log = () => {};
    }
    AppState.shared.reset();
  }

  protected readonly VehicleBrand = VehicleBrand;
  protected readonly LegalEntity = LegalEntity;

  get userName(): string {
    return AppState.shared.userName;
  }

  get legalEntity(): LegalEntity {
    return AppState.shared.legalEntity;
  }

  get consentVersion(): string {
    return AppState.shared.consentVersion;
  }
}
